import React, { useRef, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';

import { Navigation, Snackbar } from 'common';
import Form from './form';
import ParsedResume from './parsedResume';
import { useSelector } from 'react-redux';
import SrPageBanner from 'core/srPageBanner/srPageBanner';
import { IMG_MAN_WORKING } from 'images';

const useStyles = makeStyles(() => ({
  container: {
    padding: 24,
    background: '#fbfbfb',
    position: 'relative',
    marginTop: 26,
    minHeight: 'calc(100vh - 48px)',
    alignContent: 'flex-start',
  },
  bannerClass: {
    marginTop: 24,

    '& div': {
      maxWidth: 600,
    },
  },
  rightContent: {
    paddingLeft: 25,
  },
}));

const AnalyseIdCard = () => {
  const classes = useStyles();
  const [parsedResume, setParsedResume] = useState(null);
  const [isParsing, setIsParsing] = useState(false);
  const [planId, setPlanId] = useState('639b6ad9ad981e09f370dcb1');
  const bannerRef = useRef(null);
  const {
    ResumeParserFileTypeError,
    ResumeParserMultipleFilesError,
  } = useSelector((state) => state.flags);

  const updateCredits = () => {
    if (bannerRef.current) {
      bannerRef.current.getCreditCount();
    }
  };

  return (
    <>
      <Navigation />
      <Grid container classes={{ root: classes.container }}>
        <Grid container classes={{ root: classes.contentContainer }}>
          <Form
            setParsedResume={setParsedResume}
            parsedResume={parsedResume}
            isParsing={isParsing}
            setIsParsing={setIsParsing}
            setPlanId={setPlanId}
            updateCredits={updateCredits}
          />
          <Grid item xs={7} classes={{ root: classes.rightContent }}>
            <SrPageBanner
              title="Analyze IDs"
              subTitle="ID Analyser can extract and analyse important information from IDs such as name, id number, address, face images etc. Easy add-ons and configurations to mask/ remove PII and sensitive information."
              image={IMG_MAN_WORKING}
              containerClass={classes.bannerClass}
              planId={planId}
              apiLink="https://docs.senseloaf.ai/#tag/Analyze-Ids"
              bannerRef={bannerRef}
            />
            <ParsedResume
              resume={
                parsedResume && parsedResume.json ? parsedResume.json : null
              }
              fileName={parsedResume ? parsedResume.filename : ''}
              isParsing={isParsing}
            />
          </Grid>
        </Grid>
      </Grid>
      <Snackbar
        open={ResumeParserFileTypeError}
        message={'Accepts jpeg, png, pdf'}
        flag="ResumeParserFileTypeError"
      />
      <Snackbar
        open={ResumeParserMultipleFilesError}
        message={'Multiple Files are not allowed'}
        flag="ResumeParserMultipleFilesError"
      />
    </>
  );
};

export default AnalyseIdCard;
